<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css" 
      integrity="sha512-SnH5WK+bZxgPHs44uWIX+LLJAJ9/2PkPKZ5QiAj6Ta86w+fsb2TkcmfRyVX3pBnMFcV7oQPJkl9QevSCWr3W6A==" 
      crossorigin="anonymous" referrerpolicy="no-referrer" />
      
@if (showGlobalNav()) {
  <app-navbar />
}
@if (showLoginNav()) {
  <app-login-navbar />
}
@if (showTeacherRegisterNav()) {
  <app-teacher-register-navbar />
}
<router-outlet />
@if (showGlobalFooter()) {
  <app-footer />
}
